var map = {
	"./accessibility.ts": 189,
	"./advancedSearchDirective.ts": 514,
	"./aiDirectives.ts": 9029,
	"./animate.ts": 5458,
	"./assetDirectives.ts": 7039,
	"./authenticationDirective.ts": 9444,
	"./autocompleteDirectives.ts": 1883,
	"./availabilityDirective.ts": 8477,
	"./azSearchDirective.ts": 2405,
	"./backToResultsDirective.ts": 12,
	"./bxRecommenderDirectives.ts": 9784,
	"./carouselDirective.ts": 7330,
	"./chip.ts": 6367,
	"./citationTrailDirectives.ts": 4016,
	"./cloudStorageDirectives.ts": 2713,
	"./courseReservesDirectives.ts": 5991,
	"./customSearchFieldDirective.ts": 1751,
	"./customSectionsDirective.ts": 1633,
	"./daysOldDirective.ts": 8116,
	"./diagnosticsDirective.ts": 6452,
	"./directives.ts": 823,
	"./documentDirectives.ts": 7610,
	"./flow/flowDirectives.ts": 6006,
	"./homePageCustomSectionsDirective.ts": 9045,
	"./journalCoverageDirectives.ts": 906,
	"./jsonldDataDirective.ts": 5026,
	"./libraryCardDirectives.ts": 3750,
	"./publicNotes.directive.ts": 9160,
	"./refinementDirectives.ts": 9482,
	"./relatedItemsDirectives.ts": 8014,
	"./researchAssistantDirectives.ts": 9616,
	"./resultsFeedDirectives.ts": 9477,
	"./rtaAvailabilityDirective.ts": 6830,
	"./savedItemsDirectives.ts": 6430,
	"./savedSearchDirectives.ts": 6572,
	"./searchBoxDirective.ts": 7447,
	"./searchScopeDirective.ts": 3656,
	"./secondarySearchDirective.ts": 2802,
	"./shared.ts": 4672,
	"./summonAlertDirective.ts": 4737,
	"./summonAltmetricsDirective.ts": 6093,
	"./svgIcon.ts": 3526,
	"./syndeticsDirectives.ts": 2139,
	"./topicSummary.ts": 8420,
	"./validatorsDirectives.ts": 7416,
	"./widgetDirectives.ts": 1715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4635;